/* eslint-disable no-param-reassign */
import moment from 'moment';
import workloadLayout from './layout';
import workloadCore from './core';
import workloadEvents from './events';
import routerHelper from '$$routerHelper';
import constants from '$$helpers/constants';
import { checkPricingAccess } from '$$helpers/pricingHelper';
import rights from '../../../components/rights';

export default {
  init(instance) {
    if (instance.ganttDataApi.isLink() || instance.ganttDataApi.isHistory()) {
      return;
    }

    const isWorkloadGlobal = ['workload', 'workloadTaskRoute'].includes(routerHelper.getCurrentRoute().name);
    const isWorkloadTab = routerHelper.getCurrentRoute().params.mode === 'workload';
    const projectId = +routerHelper.getCurrentRoute().params.projectId;
    const multiviewId = +routerHelper.getCurrentRoute().params.multiviewID;
    const type = (isWorkloadGlobal && constants.WORKLOAD_TYPES.global) || (isWorkloadTab && constants.WORKLOAD_TYPES.tab) || constants.WORKLOAD_TYPES.panel;
    let projectIds = [];
    let workloadHeight = document.getElementsByClassName('page-wrapper')[0]?.offsetHeight; // default
    let isShow = true;
    const workloadSettings = instance.ganttDataApi.getUserActivitySettings(constants.USER_ACTIVITIES.WORKLOAD);
    let rightsAccess = true;
    let isJira = false;
    let calculationMode = 'scopedProjects';

    if (isWorkloadGlobal) {
      projectIds = instance.ganttDataApi.getAllProjects().map(o => o.id);
      calculationMode = 'allProjects';
    }
    if (multiviewId) {
      projectIds = instance.ganttDataApi.getMultiviewItem(multiviewId).ganttIDs;
    }
    if (projectId) {
      isJira = instance.ganttDataApi.getProjectItem(projectId)?.is_jira;
      projectIds = [projectId];
    }

    rightsAccess = projectIds.some(id => rights.project.hasRight(id, 'workload'));

    if (type === constants.WORKLOAD_TYPES.panel) {
      workloadHeight = workloadSettings?.workloadHeight?.[projectId || multiviewId] || constants.WORKLOAD_PANEL_DEFAULT_HEIGHT;
      isShow = workloadSettings?.panelOpenState ? workloadSettings.panelOpenState[multiviewId || projectId] : false;
      isShow = rightsAccess ? isShow : false;
      instance.config.hide_workload = !isShow;
      calculationMode = 'allProjects';

      const workloadResizer = document.querySelector('.workload-resizer');

      if (workloadResizer) {
        workloadResizer.parentNode.classList[isShow ? 'remove' : 'add']('hide');
      }
    }

    const zoom = workloadSettings?.zoom || 1;
    let range = { period: 'three_months_workload' };
    let viewMode = constants.WORKLOAD_VIEW_MODES.hours;

    if (workloadSettings) {
      if (workloadSettings.start || workloadSettings.end || workloadSettings.period) {
        range = {
          start: workloadSettings.start && moment(workloadSettings.start).toDate(),
          end: workloadSettings.end && moment(workloadSettings.end).toDate(),
          period: workloadSettings.period,
        };
      }

      if (!workloadSettings.viewMode) {
        workloadSettings.viewMode = {};
      }

      viewMode = workloadSettings.viewMode[projectId || multiviewId || constants.WORKLOAD_TYPES.global] || viewMode;
    }

    const config = {
      type,
      height: workloadHeight,
      isShow,
      rightsAccess,
      viewMode,
      calculationMode,
      projectIds,
      range,
      zoom, // 2,3,4,5
      isJira,
    };

    if (type !== constants.WORKLOAD_TYPES.panel) {
      instance.callEvent('setWorkloadZoom', [config.zoom]); // for global header view
    }

    workloadLayout.init(instance, config);

    if (!checkPricingAccess('workload')) {
      workloadEvents.initForBlockedWorkload(instance);

      return;
    }

    workloadCore.init(instance, config);
    workloadEvents.init(instance);
  },
};
